import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import LockScreen from '../../atoms/Icons/LockScreen';
import {
  patientAccessTheme,
  Typography,
} from '@HomaHealth/ui-component-library';

export interface NoTabsAccessProps {
  text: string;
}

const useStyles = makeStyles()({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
  },
});

export const NoTabsAccess: React.FC<NoTabsAccessProps> = ({ text }) => {
  const { classes } = useStyles();
  return (
    <Grid className={classes.mainContainer}>
      <LockScreen />
      <Typography
        fontSize="16px"
        fontType="semiBold"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
      >
        {text}
      </Typography>
    </Grid>
  );
};
